/**
 * Converts a Unix timestamp (seconds since epoch) to a human-readable date string
 * @param {string|number} value - The Unix timestamp to convert
 * @returns {string|*} The formatted date string or the original value if not a timestamp
 */
export const convertUnixTimestamp = value => {
  if (typeof value === 'string' && /^\d{10}$/.test(value)) {
    const timestamp = parseInt(value, 10) * 1000;
    const date = new Date(timestamp);
    if (!isNaN(date.getTime())) {
      // Format date as YYYY-MM-DD HH:MM:SSAM/PM
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';

      hours = hours % 12;
      hours = hours ? hours : 12; // Convert 0 to 12 for 12 AM
      const formattedHours = String(hours).padStart(2, '0');

      return `${year}-${month}-${day} ${formattedHours}:${minutes}:${seconds}${ampm}`;
    }
  }
  return value;
};
